const getters = {
    getExperimentChannel: state => {
        if (state.experiments.overrideChannel) {
            return state.experiments.overrideChannel;
        }
        return state.experiments.channel;
    },
    getExperimentDate: state => state.experiments.date,
    getExperimentChannelA: (state, getters) => getters.getExperimentChannel === "A"
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/ABTest/getters.js